import template from './header-root.html';

export default {
	name: 'HeaderRoot',
	created () {
		const {images} = this.$root;
		this.logoSrc = images.Logo;
		this.interval = setInterval(this.refresh, 1000);
		this.refresh();
	},
	destroyed () {
		clearInterval(this.interval);
	},
	template,
	data () {
		return {
			date: null,
			time: null,
			logoSrc: null
		};
	},
	methods: {
		refresh () {
			const now = new Date();
			this.date = now.toLocaleString('cs', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			});
			this.time = now.toLocaleString('cs', {
				hour: '2-digit',
				minute: '2-digit'
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/header/header-root.js